import { publicApi } from "../../../services/public-api"
import { SHARE_LINK_BASE_URL } from "../../Project/api/project-attachment-sharing.services"
import type { SharedFile, SharedFileResult } from "../types/shared-file.types"

const resolvePath = (token: string) =>
  `${SHARE_LINK_BASE_URL}/resolve/${encodeURIComponent(token)}/`

// The backend refuses every link that no longer leads to a file with the same
// 404 on purpose, so the page cannot tell the reasons apart either.
export const resolveSharedFile = async (
  token: string
): Promise<SharedFileResult> => {
  try {
    const { status, data } = await publicApi.get<SharedFile>(resolvePath(token))
    if (status >= 200 && status < 300) return { kind: "file", file: data }
    if (status === 404) return { kind: "gone" }
    return { kind: "error" }
  } catch {
    return { kind: "error" }
  }
}
